import { render, staticRenderFns } from "./NewChatFlowsList.vue?vue&type=template&id=e80cfae0"
import script from "./NewChatFlowsList.vue?vue&type=script&lang=js"
export * from "./NewChatFlowsList.vue?vue&type=script&lang=js"
import style0 from "./NewChatFlowsList.vue?vue&type=style&index=0&id=e80cfae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports